import { POST_LOGIN_OFFERS } from './constants';
import { PRESETS } from './presets';

/**
 * True if a post-login offer should render in its OLD (pre-redesign) design.
 *
 * Passkey enroll is always redesigned. The three enforcement offers are redesigned
 * only when the wix-2025 enforcement FT is on; when it's off they fall back to the
 * old design (the caller resets the preset), leaving passkey and the auth-screen
 * redesign unaffected. Every other offer is old-design.
 */
const isOldDesignPostLoginOffer = (
  offerId: string,
  isWix2025EnforcementEnabled: boolean,
): boolean => {
  const enforcementOffers: string[] = [
    POST_LOGIN_OFFERS.PREMIUM_USERS_2FA_ENFORCEMENT,
    POST_LOGIN_OFFERS.WIX_APP_ENFORCEMENT,
    POST_LOGIN_OFFERS.CONFIRM_EXIT_ENFORCEMENT,
  ];
  const redesignedOffers: string[] = [
    POST_LOGIN_OFFERS.PASSKEY_ENROLL,
    ...(isWix2025EnforcementEnabled ? enforcementOffers : []),
  ];
  return !redesignedOffers.includes(offerId);
};

/**
 * True if the post-login flow should reset the wix-2025 preset back to default for
 * this offer. Only meaningful when the preset is currently wix-2025 (otherwise there's
 * nothing to reset) AND the offer renders in its old design — e.g. an enforcement offer
 * while the enforcement FT is off. If the preset isn't wix-2025 (base experiment off /
 * a branded preset), this is a no-op regardless of the enforcement FT.
 */
export const shouldResetPresetForOffer = (
  presetKey: string,
  offerId: string,
  isWix2025EnforcementEnabled: boolean,
): boolean =>
  presetKey === PRESETS.WIX_2025 &&
  isOldDesignPostLoginOffer(offerId, isWix2025EnforcementEnabled);
